import httpService from "./httpService";

export default {

  findAllForHcCaseCommands(hcCaseCommandsId) {
    let params = {hcCaseCommandsId: hcCaseCommandsId};
    return httpService.get("/hcDocRelation/findAllForHcCaseCommands", {
      params: params
    });
  },

  findAllForHcCaseCommandsCommon(hcCaseCommandsCommonId) {
    let params = {hcCaseCommandsCommonId: hcCaseCommandsCommonId};
    return httpService.get("/hcDocRelation/findAllForHcCaseCommandsCommon", {
      params: params
    });
  },

  findAllForHcCongViecTrongTam(hcCongViecTrongTamId) {
    let params = {hcCongViecTrongTamId: hcCongViecTrongTamId};
    return httpService.get("/hcDocRelation/findAllForHcCongViecTrongTam", {
      params: params
    });
  },

  findAllForHcCongViecTrongTamCommon(hcCongViecTrongTamCommonId) {
    let params = {hcCongViecTrongTamCommonId: hcCongViecTrongTamCommonId};
    return httpService.get("/hcDocRelation/findAllForHcCongViecTrongTamCommon", {
      params: params
    });
  },

  findAllForHcQuyCheQuyDinh(hcQuyCheQuyDinhId) {
    let params = {hcQuyCheQuyDinhId: hcQuyCheQuyDinhId};
    return httpService.get("/hcDocRelation/findAllForHcQuyCheQuyDinh", {
      params: params
    });
  },

  findAllForHcQuyCheQuyDinhCommon(hcQuyCheQuyDinhCommonId) {
    let params = {hcQuyCheQuyDinhCommonId: hcQuyCheQuyDinhCommonId};
    return httpService.get("/hcDocRelation/findAllForHcQuyCheQuyDinhCommon", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcDocRelationService.js